import { render, staticRenderFns } from "./HeaderSearchResultsNew.vue?vue&type=template&id=13b3a447"
import script from "./HeaderSearchResultsNew.vue?vue&type=script&lang=js"
export * from "./HeaderSearchResultsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports